import lazyLoad from 'app/shared-components/util/lazyLoad';

const SchedulingCronofyReturnApp = lazyLoad(() => import('./SchedulingCronofyReturnApp'));

const SchedulingCronofyReturnAppConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'apps/scheduling/cronofy-return',
      element: <SchedulingCronofyReturnApp />,
    },
  ],
};

export default SchedulingCronofyReturnAppConfig;